import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Row, Col, Typography } from 'antd';
import { showSnackbar } from '../../../components/snackbar';
import { translateThis } from '../../../helpers/language.helper';
import { providerSignup } from '../../../services/api/auth';

const { Title } = Typography;

const toSlug = (name) =>
    name.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

const RegisterDetailsForm = ({ prefill: prefillProp, onBack }) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const location = useLocation();
    const prefill = prefillProp || location.state || {};

    const [isLoading, setIsLoading] = useState(false);
    const companyName = Form.useWatch('universityName', form);

    const handleCompanyNameBlur = (e) => {
        form.setFieldValue('url', toSlug(e.target.value));
    };

    const onFinish = async (formData) => {
        setIsLoading(true);
        const url = formData.url || toSlug(formData.universityName);

        const postData = {
            name: prefill.name || '',
            lastName: prefill.lastName || '',
            email: prefill.email || '',
            password: prefill.password || '',
            subAdminAccesses: [],
            universityName: formData.universityName,
            url,
            ...(formData.location && { location: formData.location }),
            ...(formData.website && { website: formData.website }),
            ...(formData.mobileNo && { mobileNo: formData.mobileNo }),
        };

        providerSignup(postData)
            .then((data) => {
                if (data.success) {
                    showSnackbar().success('Facility created successfully!');
                    navigate(`/${url}/auth/login`, { replace: true });
                } else if (data.message?.toLowerCase().includes('url already exists')) {
                    form.setFields([{ name: 'universityName', errors: [translateThis('A company with this name already exists. Please use a different name.')] }]);
                } else {
                    showSnackbar().failure(data.message);
                }
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <div className='login-form standard-form' style={{ maxWidth: '100%', margin: '0 auto', paddingLeft: '10px', paddingRight: '10px' }}>
            <Form
                form={form}
                name="register-details"
                onFinish={onFinish}
                layout="vertical"
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: 16 }}>
                    <Button
                        type="text"
                        onClick={() => onBack ? onBack() : navigate(-1)}
                        style={{ color: 'var(--white)', fontSize: '20px', padding: 0, lineHeight: 1 }}
                    >
                        &#x2190;
                    </Button>
                    <Title level={5} style={{ margin: 0, color: 'var(--white)' }}>
                        {translateThis('Company Details')}
                    </Title>
                </div>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label={translateThis('Company Name')}
                            name="universityName"
                            rules={[{ required: true, message: translateThis('Please enter company name!') }]}
                            style={{ marginBottom: '20px' }}
                        >
                            <Input placeholder={translateThis('Company Name')} onBlur={handleCompanyNameBlur} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label={translateThis('Location')}
                            name="location"
                            style={{ marginBottom: '20px' }}
                        >
                            <Input placeholder={translateThis('City, State')} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label={translateThis('Website')}
                            name="website"
                            style={{ marginBottom: '20px' }}
                        >
                            <Input placeholder="https://example.com" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label={translateThis('Phone')}
                            name="mobileNo"
                            style={{ marginBottom: '20px' }}
                        >
                            <Input placeholder={translateThis('Phone')} autoComplete="tel" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label={translateThis('URL')}
                            name="url"
                            style={{ marginBottom: '20px' }}
                            extra={<span style={{ color: 'rgba(255, 255, 255, 0.70)', fontSize: '13px', position: 'relative', top: '5px' }}>{translateThis('Note : This is the URL, generated from the company name')}</span>}
                        >
                            <Input disabled placeholder="e.g. my-company" />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item style={{ marginTop: '8px' }}>
                    <Button
                        className='auth-btn'
                        type="primary"
                        htmlType="submit"
                        block
                        loading={isLoading}
                        disabled={!companyName}
                    >
                        {translateThis('Complete Setup')}
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default RegisterDetailsForm;
